/* global angular */
angular.module('ua5App')
    .factory('PostsResource', ['$resource', '$rootScope', function($resource, $rootScope) {
        var url = 'api/wp-json/posts?filter[posts_per_page]=50&filter[orderby]=rand';
        if ($rootScope.dev) {
            url = url + '&time=' + Date.now();
        }
        return $resource(url, {}, {
            get: {
                method: 'GET',
                cache: true
            }
        });
    }])
;
